import { useMutation, useQuery } from "react-query";
import { useRouter } from "../../useRouter";
import { useApiError } from "src/hooks/useApiError";
import {
  applyCheckPromotionCode,
  checkPromotionTrial,
  getCashUserStatus,
  getServiceUnregisterBill,
  getTotalNxacList,
} from "src/service/pay";
import { useState } from "react";
import { IGetMyServiceListRes } from "src/service/types/console.type";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { getUserNxacList } from "src/service/cloud";

interface IUseUserNxacListProps {
  onSuccess?: () => void;
  onError?: () => void;
}
export function useUserNxacList({ onSuccess, onError }: IUseUserNxacListProps) {
  const { handleError } = useApiError();
  const { goConsole } = useRouter();
  const [isAvailable, setIsAvailable] = useState<boolean>(false);

  // check된 Nxac정보
  const { isLoading: isLoadingCheckNxacList, data: checkNxacList } = useQuery(
    ["getUserNxacList", getProductFromSessionStorage()],
    async () =>
      await getUserNxacList({
        product: getProductFromSessionStorage(),
      }),
    {
      enabled: getProductFromSessionStorage() !== null,
      onSuccess: onSuccess ? onSuccess : (res) => {},
      onError: onError ? onError : handleError,
    }
  );

  return { isLoadingCheckNxacList, checkNxacList };
}
